import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { AddCategoryComponent } from '../add-category/add-category.component';
import { GAccsessService } from 'src/app/services/g-accsess.service';
import { AddMemberComponent } from '../add-member/add-member.component';
import { GatesService } from 'src/app/services/gates.service';
import { UnitsService } from 'src/app/services/units.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { UnitBlockComponent } from '../../units/unit-block/unit-block.component';
import { MainService } from 'src/app/services/main.service';
import { AddCardComponent } from '../../units/add-card/add-card.component';
import { ClientsService } from 'src/app/services/clients.service';
import { AddNoteComponent } from '../../units/add-note/add-note.component';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  pipe = new DatePipe('en-US');
  staff_category: any;
  staff_all: any = [];
  staff_arry: any;
  selectparent = 'Staff';
  vip_category: any;
  vip_all: any = [];
  vip_arry: any;
  global_categroy: any;
  globaly_array: any;
  massage_display = false;
  All_categories: any = 'All categories';
  all_gates: any;
  all_types: any;
  filter_form: FormGroup | any;
  imageBase641: any;
  imageBase64: any;
  dataPrint: any = [];
  cardObject = {
    name: '',
    unitName: '',
    validFrom: '',
    validTo: '',
    type: '',
    image: '',
    image1: 'assets/images/teamCard.jpg',
    villageName: '',
    status: false
  };
  constructor(
    public dialog: MatDialog,
    private rest: GAccsessService,
    private unitServ: UnitsService,
    private formBuilder: FormBuilder,
    private mainService: MainService,
    private clientServ: ClientsService,
    private http: HttpClient,
    private route : Router,
    private gateServ: GatesService
  ) {}

  ngOnInit() {
    this.initFormFilet();
    // this.retrive_staff()
    this.http
      .get('/assets/images/fouka.jpg', { responseType: 'blob' })
      .subscribe((res: any) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          var base64data = reader.result;
          this.imageBase64 = base64data;
          // this.retriveVip();
          this.retrive_staff();
        };
        reader.readAsDataURL(res);
      });
    this.http
      .get('/assets/images/foukaone.jpg', { responseType: 'blob' })
      .subscribe((res: any) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          var base64data = reader.result;
          this.imageBase641 = base64data;
        };
        reader.readAsDataURL(res);
      });
  }

  initFormFilet() {
    this.filter_form = this.formBuilder.group({
      name: [''],
      access_type: [''],
      message: [''],
      controller_id: [''],
      direction: [''],
      plate_number: [''],
      unit_name: [''],
      registered_to: [''],
      valid_to: [''],
      valid_from: ['']
    });
  }

  getParent(value: any) {
    this.selectparent = value;
    if (value == 'Staff') {
      this.retrive_staff();
    } else {
      this.retriveVip();
    }
  }

  addcategory() {
    const dialogRef = this.dialog.open(AddCategoryComponent);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.rest.addCategory(result).subscribe((res: any) => {
          console.log(res);
          this.retrive_staff();
        });
      }
    });
  }

  retrive_staff() {
    this.globaly_array = [];
    this.rest.retriveStaff().subscribe((res: any) => {
      console.log(res);
      this.staff_category = Object.keys(res[0]);
      this.global_categroy = Object.keys(res[0]);
      this.staff_arry = res[0];
      this.staff_category.forEach((element: any) => {
        this.globaly_array = [...this.globaly_array, ...res[0][element]];
        this.staff_all = [...this.staff_all, ...res[0][element]];
      });
      if (this.globaly_array.length == 0) {
        this.massage_display = true;
      } else {
        this.massage_display = false;
      }
    });
  }

  filter_staff(item: any) {
    this.All_categories = item;
    if (this.selectparent == 'Staff') {
      this.globaly_array = this.staff_arry[item];
      if (this.globaly_array.length == 0) {
        this.massage_display = true;
      } else {
        this.massage_display = false;
      }
    } else {
      console.log(this.globaly_array);
      this.globaly_array = this.vip_arry[item];
      if (this.globaly_array.length == 0) {
        this.massage_display = true;
      } else {
        this.massage_display = false;
      }
    }
  }

  // retrive vip

  retriveVip() {
    this.globaly_array = [];
    this.rest.retriveVip().subscribe((res: any) => {
      console.log(res);
      this.vip_category = Object.keys(res[0]);
      this.global_categroy = Object.keys(res[0]);
      this.vip_arry = res[0];
      this.vip_category.forEach((element: any) => {
        console.log(element);
        this.globaly_array = [...this.globaly_array, ...res[0][element]];
        this.vip_all = [...this.vip_all, ...res[0][element]];
      });
      console.log(this.globaly_array);
      if (this.globaly_array.length == 0) {
        this.massage_display = true;
      } else {
        this.massage_display = false;
      }
    });
  }

  addMmber() {
    const dialogRef = this.dialog.open(AddMemberComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.rest.add_member(result).subscribe((res: any) => {
          console.log(res);
          this.retrive_staff();
        });
      }
    });
  }

  blockUnitGates(id: any) {
    let unitOrClientID: any;
    let unitOrCclientName: any;
    if (id != null) {
      unitOrClientID = id;
      unitOrCclientName = 'client';
    } else {
      unitOrClientID = '';
      unitOrCclientName = 'unit';
    }
    const dialogRef = this.dialog.open(UnitBlockComponent, {
      width: '400px',
      data: { id: unitOrClientID, name: unitOrCclientName }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (id != null) {
          let data = {
            gates: result,
            clients: [id]
          };
          if (result.balckList.length != 0) {
            data.gates = result.balckList;
            this.unitServ.balckListForClient(data).subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('Client add in blackList Gates');
            });
          } else {
            data.gates = result.WhiteList;
            console.log(data);
            this.unitServ.whiteListForClient(data).subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('Client add in whiteList Gates');
            });
          }
        }
        console.log(result);
      }
    });
  }

  addCard(value: any) {
    const dialogRef = this.dialog.open(AddCardComponent, {
      width: '450px',
      data: { id: value.id }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.client_id = value.id;
        if(result.license_plate){
          this.unitServ
            .addRfid(result)
            .then(response => response.text())
            .then(result => {
              let res = JSON.parse(result);
              if (res.status == true) {
                this.mainService.SuccessToast('RFID Added');
                this.activeClient(value.id);
              } else {
                this.mainService.erorrToast('Opss somthing worng happen!');
              }
              console.log(result);
            })
        }else {
          this.unitServ.addCard(result).subscribe((res: any) => {
            console.log(res);
            this.activeClient(value.id);
            this.mainService.SuccessToast('Card Added');
          });
        }
      }
    });
  }
  activeClient(value: any) {
    let data = {
      id: value + '',
      activated: true
    };
    this.clientServ.editClient(data).subscribe((res: any) => {
      console.log(res);
      this.mainService.SuccessToast('Client Activated');
    });
    console.log(data);
  }

  addNote(value: any, id: any) {
    let idOfClientOrUnit;
    idOfClientOrUnit = id;
    const dialogRef = this.dialog.open(AddNoteComponent, {
      width: '450px',
      data: { id: idOfClientOrUnit, name: value }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.client_id = id;
        (result.expiry_date = this.pipe.transform(new Date(), 'YYYY-MM-dd')),
          console.log(result);
        this.unitServ.addNoteForClient(result).subscribe((res: any) => {
          console.log(res);
          this.mainService.SuccessToast('Note Added for the client');
        });
      }
    });
  }

  print_card(data: any) {
    this.dataPrint = [];
    console.log(data);
    this.cardObject.name = data.name;
    if (data.type.name == 'Main Owner') {
      this.cardObject.type = 'owner' + "'s" + ' ' + 'Card';
    } else {
      this.cardObject.type = data.type.name + "'s" + ' ' + 'Card';
    }

    this.cardObject.validFrom = data.valid_from;
    this.cardObject.validTo = data.valid_to;
    // this.cardObject.unitName = this.unit_name;
    if (data.photo) {
      this.cardObject.image = data.photo;
    } else {
      this.cardObject.image = 'assets/images/avatar.png';
    }

    if (data.type.name == 'Main Owner' || data.type.name == 'Owner') {
      this.cardObject.image1 = this.imageBase641;
      this.cardObject.status = true;
    } else {
      this.cardObject.image1 = this.imageBase64;
      this.cardObject.status = false;
    }
    this.dataPrint.push(this.cardObject);
    console.log(this.dataPrint);

    setTimeout(() => {
      this.clientServ.printCardForClient(data.id).subscribe((res: any) => {
        console.log(res);
        this.mainService.SuccessToast('Printed success');
      });
      const button: any = document.getElementById('printButton');
      button.click();
      window.onafterprint = function() {
        console.log('printer');
      };
    }, 500);
  }

  editClient(value: any) {
     this.route.navigate(['pages/edit_client','', value]);
  }

  blockClientTitle = 'Block';
  clientIdDeleted:any
  openBlockClient(title: any, item: any) {
    if (title == 'block') {
      this.blockClientTitle = 'Block';
    } else {
      this.blockClientTitle = 'Active';
    }
    this.clientIdDeleted = item.id;
    const button: any = document.getElementById('btn4');
    button.click();
  }
  blockClient() {
    let data = {
      id: this.clientIdDeleted,
      cancelled: true
    };
    if (this.blockClientTitle == 'Block') {
      data.cancelled = true;
    } else {
      data.cancelled = false;
    }
    this.clientServ.editClient(data).subscribe((res: any) => {
      console.log(res);
      if (this.blockClientTitle == 'Block') {
        this.mainService.SuccessToast('Client Blocked');
      } else {
        this.mainService.SuccessToast('Client Active');
      }
      this.retrive_staff();
    });
  }


  openDeletClient(item: any) {
    this.clientIdDeleted = item.id;
    const button: any = document.getElementById('btn3');
    button.click();
  }

  DeleleClient() {
    this.unitServ.deleltClient(this.clientIdDeleted).subscribe((res: any) => {
      console.log(res);
      this.mainService.SuccessToast('Client deleted');
      this.retrive_staff();
    });
  }
}
